import { WarehouseShelvingBinSize } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const HOLD_AREA_1 = "Hold Area 1"

export const BIN_SIZE_TO_LABEL: Record<string, string> = {
  [WarehouseShelvingBinSize.XSmall]: "X-Small",
  [WarehouseShelvingBinSize.Small]: "Small",
  [WarehouseShelvingBinSize.Medium]: "Medium",
  [WarehouseShelvingBinSize.Large]: "Large",
  [WarehouseShelvingBinSize.XLarge]: "X-Large",
  [WarehouseShelvingBinSize.XxLarge]: "XX-Large",
}

export const BIN_SIZE_OPTIONS: Option<WarehouseShelvingBinSize>[] = [
  { value: WarehouseShelvingBinSize.XSmall, label: BIN_SIZE_TO_LABEL[WarehouseShelvingBinSize.XSmall] },
  { value: WarehouseShelvingBinSize.Small, label: BIN_SIZE_TO_LABEL[WarehouseShelvingBinSize.Small] },
  { value: WarehouseShelvingBinSize.Medium, label: BIN_SIZE_TO_LABEL[WarehouseShelvingBinSize.Medium] },
  { value: WarehouseShelvingBinSize.Large, label: BIN_SIZE_TO_LABEL[WarehouseShelvingBinSize.Large] },
  { value: WarehouseShelvingBinSize.XLarge, label: BIN_SIZE_TO_LABEL[WarehouseShelvingBinSize.XLarge] },
  { value: WarehouseShelvingBinSize.XxLarge, label: BIN_SIZE_TO_LABEL[WarehouseShelvingBinSize.XxLarge] },
]
